/**
 * Каталог дверей. Размеры проёма — не тип, а параметр: их правят при установке,
 * поэтому здесь типы дверей (обычная, раздвижная, под покраску) с размерами по умолчанию.
 */
import { LayerKind } from "@/shared/plan/layerKind";
import type { CatalogSection } from "../../types";
import { DoorMechanism, type DoorCatalogItem } from "./types";

export const doorSection: CatalogSection<DoorCatalogItem> = {
	kind: LayerKind.Walls,
	label: "Двери",
	canChangeDimensions: false,
	subGroups: ["Двери"],
	items: [
		{
			id: "door-900",
			subGroup: "Двери",
			name: "Обычная",
			description:
				"Распашная дверь: полотно на петлях и дуга открывания. Размер задаётся при установке.",
			color: "#39414f",
			width: 900,
			height: 2100,
			mechanism: DoorMechanism.Swing,
			leafColor: "#d9c7ac",
		},
		{
			id: "door-sliding",
			subGroup: "Двери",
			name: "Раздвижная",
			description: "Полотно едет вдоль стены по направляющей, места на открывание не нужно.",
			color: "#39414f",
			width: 900,
			height: 2100,
			mechanism: DoorMechanism.Sliding,
			leafColor: "#d9c7ac",
		},
		{
			id: "door-paintable",
			subGroup: "Двери",
			name: "Под покраску",
			description: "Распашная дверь в грунте: полотно и коробку красят после установки.",
			color: "#39414f",
			width: 900,
			height: 2100,
			mechanism: DoorMechanism.Swing,
			leafColor: "#efede7",
		},
	],
};
